export interface CustomLocale {
  label: string;
  value: string;
}
export const allLocales = [
  { label: 'af-ZA', value: 'af-ZA' },
  { label: 'am-ET', value: 'am-ET' },
  { label: 'ar-AE', value: 'ar-AE' },
  { label: 'ar-BH', value: 'ar-BH' },
  { label: 'ar-DZ', value: 'ar-DZ' },
  { label: 'ar-EG', value: 'ar-EG' },
  { label: 'ar-IQ', value: 'ar-IQ' },
  { label: 'ar-JO', value: 'ar-JO' },
  { label: 'ar-KW', value: 'ar-KW' },
  { label: 'ar-LB', value: 'ar-LB' },
  { label: 'ar-LY', value: 'ar-LY' },
  { label: 'ar-MA', value: 'ar-MA' },
  { label: 'arn-CL', value: 'arn-CL' },
  { label: 'ar-OM', value: 'ar-OM' },
  { label: 'ar-QA', value: 'ar-QA' },
  { label: 'ar-SA', value: 'ar-SA' },
  { label: 'ar-SY', value: 'ar-SY' },
  { label: 'ar-TN', value: 'ar-TN' },
  { label: 'ar-YE', value: 'ar-YE' },
  { label: 'as-IN', value: 'as-IN' },
  { label: 'az-Cyrl-AZ', value: 'az-Cyrl-AZ' },
  { label: 'az-Latn-AZ', value: 'az-Latn-AZ' },
  { label: 'ba-RU', value: 'ba-RU' },
  { label: 'be-BY', value: 'be-BY' },
  { label: 'bg-BG', value: 'bg-BG' },
  { label: 'bn-BD', value: 'bn-BD' },
  { label: 'bn-IN', value: 'bn-IN' },
  { label: 'bo-CN', value: 'bo-CN' },
  { label: 'br-FR', value: 'br-FR' },
  { label: 'bs-Cyrl-BA', value: 'bs-Cyrl-BA' },
  { label: 'bs-Latn-BA', value: 'bs-Latn-BA' },
  { label: 'ca-ES', value: 'ca-ES' },
  { label: 'co-FR', value: 'co-FR' },
  { label: 'cs-CZ', value: 'cs-CZ' },
  { label: 'cy-GB', value: 'cy-GB' },
  { label: 'da-DK', value: 'da-DK' },
  { label: 'de-AT', value: 'de-AT' },
  { label: 'de-CH', value: 'de-CH' },
  { label: 'de-DE', value: 'de-DE' },
  { label: 'de-LI', value: 'de-LI' },
  { label: 'de-LU', value: 'de-LU' },
  { label: 'dsb-DE', value: 'dsb-DE' },
  { label: 'dv-MV', value: 'dv-MV' },
  { label: 'el-GR', value: 'el-GR' },
  { label: 'en-029', value: 'en-029' },
  { label: 'en-AU', value: 'en-AU' },
  { label: 'en-BZ', value: 'en-BZ' },
  { label: 'en-CA', value: 'en-CA' },
  { label: 'en-GB', value: 'en-GB' },
  { label: 'en-IE', value: 'en-IE' },
  { label: 'en-IN', value: 'en-IN' },
  { label: 'en-JM', value: 'en-JM' },
  { label: 'en-MY', value: 'en-MY' },
  { label: 'en-NZ', value: 'en-NZ' },
  { label: 'en-PH', value: 'en-PH' },
  { label: 'en-SG', value: 'en-SG' },
  { label: 'en-TT', value: 'en-TT' },
  { label: 'en-US', value: 'en-US' },
  { label: 'en-ZA', value: 'en-ZA' },
  { label: 'en-ZW', value: 'en-ZW' },
  { label: 'es-AR', value: 'es-AR' },
  { label: 'es-BO', value: 'es-BO' },
  { label: 'es-CL', value: 'es-CL' },
  { label: 'es-CO', value: 'es-CO' },
  { label: 'es-CR', value: 'es-CR' },
  { label: 'es-DO', value: 'es-DO' },
  { label: 'es-EC', value: 'es-EC' },
  { label: 'es-ES', value: 'es-ES' },
  { label: 'es-GT', value: 'es-GT' },
  { label: 'es-HN', value: 'es-HN' },
  { label: 'es-MX', value: 'es-MX' },
  { label: 'es-NI', value: 'es-NI' },
  { label: 'es-PA', value: 'es-PA' },
  { label: 'es-PE', value: 'es-PE' },
  { label: 'es-PR', value: 'es-PR' },
  { label: 'es-PY', value: 'es-PY' },
  { label: 'es-SV', value: 'es-SV' },
  { label: 'es-US', value: 'es-US' },
  { label: 'es-UY', value: 'es-UY' },
  { label: 'es-VE', value: 'es-VE' },
  { label: 'et-EE', value: 'et-EE' },
  { label: 'eu-ES', value: 'eu-ES' },
  { label: 'fa-IR', value: 'fa-IR' },
  { label: 'fi-FI', value: 'fi-FI' },
  { label: 'fil-PH', value: 'fil-PH' },
  { label: 'fo-FO', value: 'fo-FO' },
  { label: 'fr-BE', value: 'fr-BE' },
  { label: 'fr-CA', value: 'fr-CA' },
  { label: 'fr-CH', value: 'fr-CH' },
  { label: 'fr-FR', value: 'fr-FR' },
  { label: 'fr-LU', value: 'fr-LU' },
  { label: 'fr-MC', value: 'fr-MC' },
  { label: 'fy-NL', value: 'fy-NL' },
  { label: 'ga-IE', value: 'ga-IE' },
  { label: 'gd-GB', value: 'gd-GB' },
  { label: 'gl-ES', value: 'gl-ES' },
  { label: 'gsw-FR', value: 'gsw-FR' },
  { label: 'gu-IN', value: 'gu-IN' },
  { label: 'ha-Latn-NG', value: 'ha-Latn-NG' },
  { label: 'he-IL', value: 'he-IL' },
  { label: 'hi-IN', value: 'hi-IN' },
  { label: 'hr-BA', value: 'hr-BA' },
  { label: 'hr-HR', value: 'hr-HR' },
  { label: 'hsb-DE', value: 'hsb-DE' },
  { label: 'hu-HU', value: 'hu-HU' },
  { label: 'hy-AM', value: 'hy-AM' },
  { label: 'id-ID', value: 'id-ID' },
  { label: 'ig-NG', value: 'ig-NG' },
  { label: 'ii-CN', value: 'ii-CN' },
  { label: 'is-IS', value: 'is-IS' },
  { label: 'it-CH', value: 'it-CH' },
  { label: 'it-IT', value: 'it-IT' },
  { label: 'iu-Cans-CA', value: 'iu-Cans-CA' },
  { label: 'iu-Latn-CA', value: 'iu-Latn-CA' },
  { label: 'ja-JP', value: 'ja-JP' },
  { label: 'ka-GE', value: 'ka-GE' },
  { label: 'kk-KZ', value: 'kk-KZ' },
  { label: 'kl-GL', value: 'kl-GL' },
  { label: 'km-KH', value: 'km-KH' },
  { label: 'kn-IN', value: 'kn-IN' },
  { label: 'kok-IN', value: 'kok-IN' },
  { label: 'ko-KR', value: 'ko-KR' },
  { label: 'ky-KG', value: 'ky-KG' },
  { label: 'lb-LU', value: 'lb-LU' },
  { label: 'lo-LA', value: 'lo-LA' },
  { label: 'lt-LT', value: 'lt-LT' },
  { label: 'lv-LV', value: 'lv-LV' },
  { label: 'mi-NZ', value: 'mi-NZ' },
  { label: 'mk-MK', value: 'mk-MK' },
  { label: 'ml-IN', value: 'ml-IN' },
  { label: 'mn-MN', value: 'mn-MN' },
  { label: 'mn-Mong-CN', value: 'mn-Mong-CN' },
  { label: 'moh-CA', value: 'moh-CA' },
  { label: 'mr-IN', value: 'mr-IN' },
  { label: 'ms-BN', value: 'ms-BN' },
  { label: 'ms-MY', value: 'ms-MY' },
  { label: 'mt-MT', value: 'mt-MT' },
  { label: 'nb-NO', value: 'nb-NO' },
  { label: 'ne-NP', value: 'ne-NP' },
  { label: 'nl-BE', value: 'nl-BE' },
  { label: 'nl-NL', value: 'nl-NL' },
  { label: 'nn-NO', value: 'nn-NO' },
  { label: 'nso-ZA', value: 'nso-ZA' },
  { label: 'oc-FR', value: 'oc-FR' },
  { label: 'or-IN', value: 'or-IN' },
  { label: 'pa-IN', value: 'pa-IN' },
  { label: 'pl-PL', value: 'pl-PL' },
  { label: 'prs-AF', value: 'prs-AF' },
  { label: 'ps-AF', value: 'ps-AF' },
  { label: 'pt-BR', value: 'pt-BR' },
  { label: 'pt-PT', value: 'pt-PT' },
  { label: 'qut-GT', value: 'qut-GT' },
  { label: 'quz-BO', value: 'quz-BO' },
  { label: 'quz-EC', value: 'quz-EC' },
  { label: 'quz-PE', value: 'quz-PE' },
  { label: 'rm-CH', value: 'rm-CH' },
  { label: 'ro-RO', value: 'ro-RO' },
  { label: 'ru-RU', value: 'ru-RU' },
  { label: 'rw-RW', value: 'rw-RW' },
  { label: 'sah-RU', value: 'sah-RU' },
  { label: 'sa-IN', value: 'sa-IN' },
  { label: 'se-FI', value: 'se-FI' },
  { label: 'se-NO', value: 'se-NO' },
  { label: 'se-SE', value: 'se-SE' },
  { label: 'si-LK', value: 'si-LK' },
  { label: 'sk-SK', value: 'sk-SK' },
  { label: 'sl-SI', value: 'sl-SI' },
  { label: 'sma-NO', value: 'sma-NO' },
  { label: 'sma-SE', value: 'sma-SE' },
  { label: 'smj-NO', value: 'smj-NO' },
  { label: 'smj-SE', value: 'smj-SE' },
  { label: 'smn-FI', value: 'smn-FI' },
  { label: 'sms-FI', value: 'sms-FI' },
  { label: 'sq-AL', value: 'sq-AL' },
  { label: 'sr-Cyrl-BA', value: 'sr-Cyrl-BA' },
  { label: 'sr-Cyrl-CS', value: 'sr-Cyrl-CS' },
  { label: 'sr-Cyrl-ME', value: 'sr-Cyrl-ME' },
  { label: 'sr-Cyrl-RS', value: 'sr-Cyrl-RS' },
  { label: 'sr-Latn-BA', value: 'sr-Latn-BA' },
  { label: 'sr-Latn-CS', value: 'sr-Latn-CS' },
  { label: 'sr-Latn-ME', value: 'sr-Latn-ME' },
  { label: 'sr-Latn-RS', value: 'sr-Latn-RS' },
  { label: 'sv-FI', value: 'sv-FI' },
  { label: 'sv-SE', value: 'sv-SE' },
  { label: 'sw-KE', value: 'sw-KE' },
  { label: 'syr-SY', value: 'syr-SY' },
  { label: 'ta-IN', value: 'ta-IN' },
  { label: 'te-IN', value: 'te-IN' },
  { label: 'tg-Cyrl-TJ', value: 'tg-Cyrl-TJ' },
  { label: 'th-TH', value: 'th-TH' },
  { label: 'tk-TM', value: 'tk-TM' },
  { label: 'tn-ZA', value: 'tn-ZA' },
  { label: 'tr-TR', value: 'tr-TR' },
  { label: 'tt-RU', value: 'tt-RU' },
  { label: 'tzm-Latn-DZ', value: 'tzm-Latn-DZ' },
  { label: 'ug-CN', value: 'ug-CN' },
  { label: 'uk-UA', value: 'uk-UA' },
  { label: 'ur-PK', value: 'ur-PK' },
  { label: 'uz-Cyrl-UZ', value: 'uz-Cyrl-UZ' },
  { label: 'uz-Latn-UZ', value: 'uz-Latn-UZ' },
  { label: 'vi-VN', value: 'vi-VN' },
  { label: 'wo-SN', value: 'wo-SN' },
  { label: 'xh-ZA', value: 'xh-ZA' },
  { label: 'yo-NG', value: 'yo-NG' },
  { label: 'zh-CN', value: 'zh-CN' },
  { label: 'zh-HK', value: 'zh-HK' },
  { label: 'zh-MO', value: 'zh-MO' },
  { label: 'zh-SG', value: 'zh-SG' },
  { label: 'zh-TW', value: 'zh-TW' },
  { label: 'zu-ZA', value: 'zu-ZA' },
];
